import React, { useState, useContext } from "react";
import { Box, Typography, Button, Paper, useMediaQuery, useTheme } from "@mui/material";
import { ThemeContext } from "../context/ThemeContextProvider";
import CashBanks from "../components/PagesComponents/AccountsComponents/BanksSafes/CashBankslists";
import ExpensesList from "../components/PagesComponents/AccountsComponents/Expenses/ExpensesList";

const Accounts = () => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedSection, setSelectedSection] = useState("cashBanks");

  return (
    <Box sx={{ 
      p: { xs: 1, sm: 2, md: 3 }, 
      bgcolor: mode === "dark" ? "#1F1D2B" : "#F5F5F5", 
      color: mode === "dark" ? "#fff" : "#000",
      minHeight: "100vh",
    }}>
      <Typography 
        variant={isMobile ? "h5" : "h4"} 
        sx={{ 
          mb: { xs: 1.5, sm: 2 }, 
          fontWeight: "bold",
          fontSize: { xs: "20px", sm: "24px", md: "32px" },
        }}
      >
        الحسابات المالية
      </Typography>
      
      <Box sx={{ 
        display: "flex", 
        gap: { xs: 1, sm: 1.5, md: 2 }, 
        mb: { xs: 2, sm: 2.5, md: 3 },
        flexDirection: { xs: "column", sm: "row" },
        width: { xs: "100%", sm: "auto" },
      }}>
        <Button 
          variant={selectedSection === "cashBanks" ? "contained" : "outlined"} 
          onClick={() => setSelectedSection("cashBanks")}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{
            fontSize: { xs: "13px", sm: "14px", md: "16px" },
            py: { xs: 1, sm: 1.2 },
            textTransform: "none",
            fontWeight: selectedSection === "cashBanks" ? 600 : 500,
          }}
        >
          الخزن والبنوك
        </Button>
        <Button
          variant={selectedSection === "expenses" ? "contained" : "outlined"}
          onClick={() => setSelectedSection("expenses")}
          fullWidth={isMobile}
          size={isMobile ? "medium" : "large"}
          sx={{
            fontSize: { xs: "13px", sm: "14px", md: "16px" },
            py: { xs: 1, sm: 1.2 },
            textTransform: "none",
            fontWeight: selectedSection === "expenses" ? 600 : 500,
          }}
        >
          المصروفات
        </Button>
      </Box>
      
      <Paper 
        elevation={isMobile ? 2 : 3}
        sx={{ 
          p: { xs: 1, sm: 2, md: 3 }, 
          bgcolor: mode === "dark" ? "#2C2A3A" : "#fff",
          borderRadius: { xs: 2, md: 2 },
          overflow: "hidden",
        }}
      >
        {selectedSection === "cashBanks" && <CashBanks />}
        {selectedSection === "expenses" && <ExpensesList />}
      </Paper>
    </Box>
  );
};

export default Accounts;
